export const getWebsiteAndBusinessStyles = () => ({
  container: {
    width: '440px',
    marginTop: '30px',
    '& .error': { color: '#a80000' },
  },
  businessName: { maxWidth: '440px' },
});

export const websiteAndBusinessStyles = {
  title: { root: { fontWeight: 600, marginBottom: '5px', textAlign: 'center' } },
  titleWithMargin: { root: { fontWeight: 600, marginBottom: '5px', marginTop: '16px' } },
  website: { maxWidth: '440px' },
} as const;

export const getWebsiteAndSmartPagesStyles = () => ({
  container: {
    width: '100%',
    maxWidth: 400,
    marginTop: '30px',
    display: 'flex',
    flexFlow: 'column',
    '& .error': { color: '#a80000' },
  },
  websiteItemContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 18,
  },
  selectedOptionContainer: {
    borderColor: 'transparent',
    boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0.9px rgba(0, 0, 0, 0.108)',
    padding: '20px',
  },
  smartPageErrors: {
    paddingTop: '5px',
  },
});

const websiteItemMarginRight = '16px';

export const websiteAndSmartPagesStyles = {
  websiteInput: { maxWidth: '320px', marginTop: '8px' },
  title: { root: { fontWeight: 600 } },
  link: { root: { fontWeight: 400 } },
} as const;

export const getWebsiteItemStyles = () => ({
  item: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column',
    width: `calc((100% - ${websiteItemMarginRight}) / 2)`,
    backgroundColor: '#fff !important',
    border: '2px solid',
    position: 'relative',
  },
  itemContainerRebranding: {
    '& .ms-Image-image': {
      marginTop: '20px',
    },
  },
  itemContainerWithIcon: {
    padding: '34px 20px 20px',
  },
  itemContainerWithoutIcon: {
    padding: '0px 20px 20px',
  },
  optionSelected: {
    borderColor: '#0078D4',
  },
  optionNotSelected: {
    borderColor: 'transparent',
    boxShadow: '0px 1.6px 3.6px rgba(0, 0, 0, 0.132), 0px 0.3px 0.9px rgba(0, 0, 0, 0.108)',
  },
  imgContainer: {
    marginBottom: '-25px',
    height: '126px',
  },
  icon: {
    color: '#0078D4',
    fontSize: '20px',
    position: 'absolute',
    top: '9px',
    right: '14px',
  },
  iconNotSelected: {
    color: '#323130',
    fontSize: '20px',
    position: 'absolute',
    top: '9px',
    right: '14px',
  },
});

export const websiteItemStyles = {
  title: { root: { fontWeight: 600 } },
  image: { root: { marginBottom: 10 } },
} as const;

export const getWebsiteInputStyles = () => ({
  websiteInputContainer: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'start',
    width: '100%',
  },
});
